import type { ReactNode } from "react";

import { DefaultConnectionIcon } from "@/assets/icons";

export const getIcon = (): ReactNode => {
  return <DefaultConnectionIcon />;
};
